/**
 * Represents the mode of an [[OrderBooking]].
 *
 * @remarks
 * Primarily used to control the booking fee behaviour.
 */
export var OrderBookingMode;
(function (OrderBookingMode) {
    /**
     * Standard paid booking.
     */
    OrderBookingMode["Paid"] = "Paid";
    /**
     * Unpaid booking.
     */
    OrderBookingMode["Unpaid"] = "Unpaid";
    /**
     * Unpaid booking with an extended collection period.
     */
    OrderBookingMode["UnpaidConfirmed"] = "UnpaidConfirmed";
})(OrderBookingMode || (OrderBookingMode = {}));
//# sourceMappingURL=order-booking-mode.js.map